import React from 'react';
import Button from '@material-ui/core/Button';
import HomeLayout from '../Layouts/homeLayout';

const EcardSalesPage = () =>
{
	return (
		<div className='flexCol alignCntr baseBg fullHeight pdngLG dashboardCntnr'>
			<div className='flexCol alignCntr whiteTxt LinearGradientGreen brdrRadiusSM pdngXS'>
				<h3 className='fontWeightNormal textCntr'>FEATURES OF KONX ECARD FOR FREE</h3>
			</div>
			<div className='flexCol justifyBtwn alignCntr pdngVLG mrgnTXLG'>
				<div className='flexAutoCol'>
					<h3 className='textCntr pdngVMD bold'>KONX ECARD FOR SALES AGENT</h3>
					<div className='flexCol alignCntr pdngVSM'>
						<ul className='flexCol alignCntr featuresCntnr'>
							<li className='flexRow justifyCntr features textCntr pdngVSM'><small className='bold'> Use your KonX eCard for 50 hours for Free</small></li>
							<li className='flexRow justifyCntr features textCntr pdngVSM'><small className='bold'> Can invite up to 500 Participants in one Session/Conference Call</small></li>
							<li className='flexRow justifyCntr features textCntr pdngVSM'><small className='bold'> Use it ONLY when you need it!</small></li>
						</ul>
					</div>
				</div>
				<div className='flexCol alignCntr appkey LinearGradientGreen brdrRadiusSM mrgnTXLG'>
					<Button className='whiteTxt'>
						Activate
					</Button>
				</div>
			</div>
			<div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM mrgnTXLG'>
				<h3 className='pdngXXS'>www.konx.biz</h3>
			</div>
		</div>
	);
};

export default HomeLayout(EcardSalesPage);